import React from 'react';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import './account_details.css';

const AccountDetails = (props) => {
  const {
    accountNameText,
    abnText,
    customerAccountName,
    customerAbn,
    customerAccountNumber,
    accountNumberText,
    accessedByText,
    onText,
    staffAccessInfoList,
  } = props;

  const getDPNumber = staffAccessInfoList
    ? staffAccessInfoList.slice(0, 1).map(no => no.accessedBy)
    : 'n/a';

  const getLastAccessedDate = staffAccessInfoList
    ? new Date(staffAccessInfoList.slice(0, 1).map(no => no.accessedAt)).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : "n/a";

  return (
    <div className="ri-confirm-detail-section">
      <div className="row customer-attirbutes">
        <div className="col-sm-12 col-md-4 pl-0">
          <div className="row account-section">
            <div className="col-12">
              <SvgIcon name="icon-product-business-small-building" className="custom-svg-class" />
              <span className="heading16 account-label-text">{accountNameText} </span>
            </div>
            <div className="col-12 account-value-section">
              <span className="account-value-text">{customerAccountName}</span>
            </div>
            <div className="col-12 account-accessed-section">
              <span className="accessed-text-value">{accessedByText} {getDPNumber} {onText} {getLastAccessedDate} </span>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4 pl-0">
          <div className="row">
            <div className="col-12">
              <SvgIcon name="icon-authentication-my-details" className="custom-svg-class" />
              <span className="heading16 account-label-text">{abnText} </span>
            </div>
            <div className="col-12 account-value-section">
              <span className="account-value-text">{customerAbn}</span>
            </div>
          </div>
        </div>
        {customerAccountNumber &&
          <div className="col-sm-12 col-md-4 pl-0">
            <div className="row">
              <div className="col-12">
                <SvgIcon name="icon-authentication-my-details" className="custom-svg-class" />
                <span className="heading16 account-label-text">{accountNumberText} </span>
              </div>
              <div className="col-12 account-value-section">
                <span className="account-value-text">{customerAccountNumber}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default AccountDetails;
